import { ERegions } from '../../constants';
import { IAppState } from '../../redux';

export const selectUserGeoId = (state: IAppState): number => {
  return state.user.geo?.id || ERegions.moscow;
};
